import React from 'react';
import { useIntl } from 'react-intl-next';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { externalMediaMessages } from '../media';
var baseStyles = xcss({
  borderRadius: 'border.radius',
  backgroundColor: 'elevation.surface',
  // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
  lineHeight: "var(--ds-space-200, 16px)",
  cursor: 'pointer'
});

// On cleanup of 'platform_editor_hide_external_media_badge', make types non-optional

var NO_EXTERNAL_BADGE_HOSTS = ['atlassian.com'];
export var isUnbadgedUrl = function isUnbadgedUrl(url) {
  var hostname;
  try {
    var _URL = new URL(url || '');
    hostname = _URL.hostname;
  } catch (e) {
    // If the URL is invalid (or empty), just carry on showing the badge
    return false;
  }
  return Boolean(hostname &&
  // Do not show badge for atlassian domains and subdomains
  NO_EXTERNAL_BADGE_HOSTS.some(function (host) {
    return hostname === host || hostname.endsWith(".".concat(host));
  }));
};
export var ExternalImageBadge = function ExternalImageBadge(_ref) {
  var badgeSize = _ref.badgeSize,
    type = _ref.type,
    url = _ref.url;
  var intl = useIntl();
  var message = intl.formatMessage(externalMediaMessages.externalMediaFile);
  if (fg('platform_editor_hide_external_media_badge')) {
    if (type !== 'external' || isUnbadgedUrl(url)) {
      return null;
    }
  }
  return /*#__PURE__*/React.createElement(Box, {
    padding: badgeSize === 'medium' ? 'space.050' : 'space.0',
    xcss: baseStyles,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: message,
    position: "top"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    size: "small",
    label: message
  })));
};